module.exports = __webpack_public_path__ + "media/images/agreements/link_3-778dd5376747567b893d13e301b90e0f.png";